import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import FormModal from '../../Modals/FormModal';
import InputField from '../../Forms/Input/InputField';

interface EditBrandPopupProps {
  popupOpen: boolean;
  setPopupOpen: (open: boolean) => void;
  onUpdate: (brandData: { id: number; name: string }) => void;
  selectedBrand: { id: number; name: string } | null;
}

const EditBrandPopup: React.FC<EditBrandPopupProps> = ({
  popupOpen,
  setPopupOpen,
  onUpdate,
  selectedBrand,
}) => {
  const validationSchema = Yup.object({
    name: Yup.string()
      .min(2, 'El nombre debe tener al menos 2 caracteres')
      .required('El nombre de la marca es obligatorio'),
  });

  const formik = useFormik({
    initialValues: {
      id: selectedBrand?.id || 0,
      name: selectedBrand?.name || '',
    },
    validationSchema,
    onSubmit: (values) => {
      onUpdate(values);
      setPopupOpen(false);
    },
    enableReinitialize: true,
  });

  return (
    <FormModal
      isOpen={popupOpen}
      onClose={() => setPopupOpen(false)}
      title="Editar Marca"
      maxWidth="max-w-md"
    >
      <form onSubmit={formik.handleSubmit} className="mt-4">
        <InputField
          label="Nombre"
          name="name"
          type="text"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={
            formik.touched.name && formik.errors.name
              ? formik.errors.name
              : undefined
          }
          iconKey="edit"
        />

        <button
          type="submit"
          className="w-full rounded bg-primary px-4 py-2 font-medium text-white hover:bg-opacity-90"
        >
          Guardar Cambios
        </button>
      </form>
    </FormModal>
  );
};

export default EditBrandPopup;